// fixed set of allowed variables to replace in content
const ValidEmailVariables = ['company', 'location'];

export const correctUseOfVariables = async (_, value) => {
  // no variables
  if (!/[{{}}]/.test(value)) return Promise.resolve();
  const toReplace = [...value.matchAll(/{{.+?}}/g)];
  // validate identified variables
  for (let v of toReplace) {
    if (!ValidEmailVariables.includes(v[0].slice(3, -3))) {
      return Promise.reject(new Error(`Incorrect use of variables: ${v[0]} at position ${v['index']}`));
    }
  }

  // orphan opening tags
  if (/\{\{(?:(?!\}\}).)*$/.test(value)) {
    return Promise.reject(new Error('Invalid input: there are orphan curly brackets'));
  }
  return Promise.resolve();
};

export const correctVariablesRule = {
  validator: correctUseOfVariables,
};
